import { useState } from 'react'

import { EuiText, EuiFlexItem, EuiFlexGroup, EuiButton } from '@elastic/eui'

interface ResearchDocumentProps {
  title: string
  description: string
  onDownload: () => Promise<void>
  isDownloadDisabled?: boolean
}

export const ResearchDocumentSectionOld = ({ title, description, onDownload, isDownloadDisabled }: ResearchDocumentProps) => {
  const [isLoading, setIsLoading] = useState(false)

  const onDownloadClick = async () => {
    setIsLoading(true)
    await onDownload()
    setIsLoading(false)
  }

  return (
    <>
      <EuiText>
        <b>{title}</b>
      </EuiText>
      <EuiFlexGroup>
        <EuiFlexItem grow={5}>
          <EuiText>{description}</EuiText>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButton size='s' fullWidth={false} onClick={onDownloadClick} disabled={isDownloadDisabled} iconType='popout' isLoading={isLoading}>
            Download PDF
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem />
      </EuiFlexGroup>
    </>
  )
}
